import { render, staticRenderFns } from "./AccountsDetailRow.vue?vue&type=template&id=5dcdac78&"
import script from "./AccountsDetailRow.vue?vue&type=script&lang=js&"
export * from "./AccountsDetailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports